/**
 * Configuración de los feature flags de LaunchDarkly
 *
 * Cada flag lleva su key en LaunchDarkly y el valor que se usa cuando el SDK no
 * responde (sin client ID, red caída, bloqueador de anuncios…). Los defaults son
 * "fail-open": si LaunchDarkly no contesta, la app sigue funcionando.
 */

export const FEATURE_FLAGS = {
  // Todo el sistema en mantenimiento: se muestra la pantalla de mantenimiento en cualquier ruta
  MAINTENANCE_MODE: {
    key: 'scae-maintenance-mode',
    default: false,
  },
  // Pagos en mantenimiento: las rutas con meta.isPayment muestran el aviso en lugar
  // del checkout y el store rechaza enviar pagos
  PAYMENTS_MAINTENANCE: {
    key: 'scae-payments-maintenance',
    default: false,
  },
};

export const FEATURE_FLAGS_CONFIG = {
  // Segundos máximos que la primera navegación espera a LaunchDarkly antes de seguir
  // con el valor en caché (o el default)
  INIT_TIMEOUT_SECONDS: 3,

  APPLICATION_ID: 'scae-frontend',
};
